import { render, staticRenderFns } from "./RtnInvoiceRelated_Row_Total.vue?vue&type=template&id=6618a61c&"
import script from "./RtnInvoiceRelated_Row_Total.vue?vue&type=script&lang=js&"
export * from "./RtnInvoiceRelated_Row_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports